import { filterPolicyEndorsementsForApiResponse } from "./endorsement-supersession";

export interface PolicyPeriodDates {
	fromDate: string;
	toDate: string;
}

export function withPreviousPolicyPeriod<T extends PolicyPeriodDates> (
	payload: T,
	current: { startDate: string; endDate: string },
): T & { previousFromDate: string; previousToDate: string } {
	return {
		...payload,
		previousFromDate: current.startDate,
		previousToDate: current.endDate,
	};
}

export function policyPeriodRevisionError ({ fromDate, toDate }: PolicyPeriodDates): string | null {
	const validDate = (value: string) => {
		if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
		const date = new Date(`${value}T00:00:00.000Z`);
		return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
	};
	if (!validDate(fromDate) || !validDate(toDate)) return "Enter valid policy period dates";
	if (fromDate >= toDate) return "The policy period end must be after its start";
	return null;
}

export function activeEndorsementOutsidePolicyPeriod (
	rows: Array<{ id: string; slug: string; data: unknown; effectiveDate: string | null }>,
	period: { startDate: string; endDate: string },
): boolean {
	return filterPolicyEndorsementsForApiResponse(rows).some(row => row.slug !== "deletion"
		&& row.effectiveDate !== null
		&& (row.effectiveDate < period.startDate || row.effectiveDate > period.endDate));
}
